import { useState } from "react";
import { db } from "./firebaseConfig";
import { collection, addDoc } from "firebase/firestore";
import { toast } from "react-toastify";
import AdminNavbar from "../layouts/AdminNavbar";
import Footer from "../layouts/Footer";

const Upload = () => {
  const access = sessionStorage.getItem("mandftoken");

  if (!access) {
    window.location.href = "/";
    sessionStorage.setItem("mandftoken", "");
    toast.info("You are not allowed to view this page.");
  }

  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");
  const [category, setCategory] = useState("");
  const [status, setStatus] = useState(false);
  const [sold, setSold] = useState("false");
  const [files, setFiles] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const handleFileChange = (e) => {
    const selectedFiles = e.target.files;
    setFiles([...files, ...selectedFiles]);
  };

  const uploadToCloudinary = async (file) => {
    const formData = new FormData();
    formData.append("file", file);

    try {
      const response = await fetch("/api/upload", {
        method: "POST",
        body: formData,
      });

      const data = await response.json();

      if (!data.success) {
        throw new Error(data.message || "Upload failed");
      }

      return data.imageUrl;
    } catch (error) {
      console.error("Cloudinary upload error:", error);
      throw error;
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (files.length === 0) {
      alert("Please select at least one file!");
      return;
    }

    try {
      setIsLoading(true);

      // Upload all files to Cloudinary first
      const uploadPromises = files.map((file) => uploadToCloudinary(file));
      const imageUrls = await Promise.all(uploadPromises);

      // Add a new document with all data including image URLs
      const docRef = await addDoc(collection(db, "products"), {
        title: title,
        description: description,
        category: category,
        status: status,
        sold: sold === "true",
        imageUrls: imageUrls,
        createdAt: new Date(),
      });

      toast.success("Product uploaded successfully");
      setIsLoading(false);

      // Reset the form
      setCategory("");
      setTitle("");
      setStatus(false);
      setSold("false");
      setDescription("");
      setFiles([]);

      // Reset file input
      document.querySelector('input[type="file"]').value = "";
    } catch (error) {
      console.error("Error uploading product: ", error);
      toast.error("Error uploading product: " + error.message);
      setIsLoading(false);
    }
  };

  return (
    <>
      <AdminNavbar />
      <section className="ftco-section">
        <div className="container">
          <div className="row justify-content-start mb-5 pb-2">
            <div className="col-md-4 heading-section">
              <span className="subheading subheading-with-line">
                <small className="pr-2 bg-white">Upload Products</small>
              </span>
            </div>
            <div className="col-md-8 pl-md-5 heading-section">
              <div className="pl-md-4 border-line">
                <form onSubmit={handleSubmit}>
                  <div className="form-group">
                    <input
                      type="text"
                      value={title}
                      onChange={(e) => setTitle(e.target.value)}
                      placeholder="Title"
                      className="form-control"
                      required
                    />
                  </div>
                  <div className="form-group">
                    <select
                      value={category}
                      onChange={(e) => setCategory(e.target.value)}
                      required
                      className="form-control"
                    >
                      <option value="">Select Category</option>
                      <option value="furniture">Furniture</option>
                      <option value="lighting">Lighting</option>
                      <option value="vases">Vases/Pots</option>
                      <option value="mirror">Mirrors</option>
                      <option value="plants">Plants</option>
                      <option value="accessories">Accessories</option>
                      <option value="wallart">Wall Art</option>
                    </select>
                  </div>
                  <div className="form-group">
                    <select
                      value={status}
                      onChange={(e) => setStatus(e.target.value === "true")}
                      required
                      className="form-control"
                    >
                      <option value="false">Select Status</option>
                      <option value="true">Latest</option>
                    </select>
                  </div>
                  <div className="form-group">
                    <select
                      value={sold}
                      onChange={(e) => setSold(e.target.value)}
                      required
                      className="form-control"
                    >
                      <option value="">Select Sold out status</option>
                      <option value="true">Sold</option>
                      <option value="false">Not Sold</option>
                    </select>
                  </div>
                  <div className="form-group">
                    <textarea
                      className="form-control"
                      value={description}
                      onChange={(e) => setDescription(e.target.value)}
                      placeholder="Description"
                      required
                    ></textarea>
                  </div>
                  <div className="form-group">
                    <input
                      type="file"
                      onChange={handleFileChange}
                      className="form-control"
                      multiple
                      accept="image/*"
                      required
                    />
                    {files.length > 0 && (
                      <small className="form-text text-muted">
                        {files.length} file(s) selected
                      </small>
                    )}
                  </div>
                  <div className="form-group">
                    {isLoading ? (
                      <input
                        type="submit"
                        value="Uploading..."
                        disabled
                        className="btn btn-primary py-3 px-5"
                      />
                    ) : (
                      <input
                        type="submit"
                        value="Upload"
                        className="btn btn-primary py-3 px-5"
                      />
                    )}
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </>
  );
};

export default Upload;
